import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreatedOrder } from 'src/models/DTO/orders/createdOrder';
import { OrderCollection } from 'src/models/DTO/orders/orderCollection';
import { Config } from '../../../infrastructure/config';
import { CreateOrderRequestModel } from '../../../models/requestModels/orders/CreateOrderRequestModel';


@Injectable({
  providedIn: 'root'
})
export class OrderService {

  private orderURL: string = Config.api + "order";
  private droupOrder: string = Config.api + "order/group-order";


  constructor(
    private httpClient: HttpClient
  ) { }

  public createOrder(createOrderRequestModel: CreateOrderRequestModel) {
    return this.httpClient.post<any>(this.orderURL, createOrderRequestModel);
  }

  public cleanupFailedPayment(paymentIntentId: string) {
    return this.httpClient.post<any>(this.orderURL + '/payment-failed', {
      payment_intent_id: paymentIntentId
    });
  }

  // Request route for order info
  public getCurrentOrder(orderUUID: string) {
        return this.httpClient.get<CreatedOrder>(this.orderURL + '/' + orderUUID);
  }

   // Request route for all orders
  public getAllOrders(perPage: number, currentPage :number, sort: string, datebefore: number) {
    return this.httpClient.get<OrderCollection>(this.orderURL + '?include=group,shipment,user,lines,delivery_address,invoice_address,lines.sku,lines.sku.product,lines.sku.product.organisation,lines.sku.product.pricing,lines.sku.options,lines.sku.options.option,lines.sku.options.option.values&fields[skus]=id,uuid,product_id,sku&sort=newest&perPage=' + perPage.toString() + '&page=' + currentPage);
  }

  public getOrder(orderId: string) {
    return this.httpClient.get<CreatedOrder>(this.orderURL + '/' + orderId + '?include=paymentMethod,group,shipment,user,lines,delivery_address,invoice_address,lines.sku,lines.sku.product,lines.sku.product.organisation,lines.sku.product.pricing,lines.sku.options,lines.sku.options.option,lines.sku.options.option.values&fields[skus]=id,uuid,product_id,sku');
  }
}
